// @flow
import loadable from '@loadable/component';
import * as componentKeys from 'componentKeys';

const AngledBackgroundGroup = {
  asyncComponentName: 'editable/AngledBackgroundGroup',
  AsyncComponent: loadable(() => import('../AngledBackgroundGroup'))
};
const Cards = {
  asyncComponentName: 'editable/Cards',
  AsyncComponent: loadable(() => import('../Cards'))
};
const Callout = {
  asyncComponentName: 'editable/Callout',
  AsyncComponent: loadable(() => import('../Callout'))
};
const SimpleContentCallout = {
  asyncComponentName: 'editable/SimpleContentCallout',
  AsyncComponent: loadable(() => import('../SimpleContentCallout'))
};
const ParagraphWithImage = {
  asyncComponentName: 'editable/ParagraphWithImage',
  AsyncComponent: loadable(() => import('../ParagraphWithImage'))
};
const ContentBlock = {
  asyncComponentName: 'editable/ContentBlock',
  AsyncComponent: loadable(() => import('../ContentBlock'))
};
const ImageBlock = {
  asyncComponentName: 'editable/ImageBlock',
  AsyncComponent: loadable(() => import('../ImageBlock'))
};
const Testimonial = {
  asyncComponentName: 'editable/Testimonial',
  AsyncComponent: loadable(() => import('../Testimonial'))
};
const YoutubeVideo = {
  asyncComponentName: 'editable/YoutubeVideo',
  AsyncComponent: loadable(() => import('../YoutubeVideo'))
};
const Bookmark = {
  asyncComponentName: 'editable/Bookmark',
  AsyncComponent: loadable(() => import('../Bookmark'))
};
const BlogAggregateCategory = {
  asyncComponentName: 'editable/blog/AggregateCategory',
  AsyncComponent: loadable(() => import('../blog/AggregateCategory'))
};
const BlogAggregatePosts = {
  asyncComponentName: 'editable/blog/AggregatePosts',
  AsyncComponent: loadable(() => import('../blog/AggregatePosts'))
};
const Job = {
  asyncComponentName: 'editable/Job',
  AsyncComponent: loadable(() => import('../Job'))
};
const CompanyProfile = {
  asyncComponentName: 'editable/CompanyProfile',
  AsyncComponent: loadable(() => import('../CompanyProfile'))
};
const TeamBlock = {
  asyncComponentName: 'editable/TeamBlock',
  AsyncComponent: loadable(() => import('../TeamBlock'))
};
const TeamProfile = {
  asyncComponentName: 'editable/TeamProfile',
  AsyncComponent: loadable(() => import('../TeamProfile'))
};
const ShopsList = {
  asyncComponentName: 'editable/ShopsList',
  AsyncComponent: loadable(() => import('../ShopsList'))
};

const componentMap = {
  [componentKeys.ANGLED_BACKGROUND_GROUP]: AngledBackgroundGroup,
  [componentKeys.BLOG_AGGREGATE_CATEGORY]: BlogAggregateCategory,
  [componentKeys.BLOG_AGGREGATE_POSTS]: BlogAggregatePosts,
  [componentKeys.CARDS]: Cards,
  [componentKeys.CALLOUT]: Callout,
  [componentKeys.COMPANY_PROFILE]: CompanyProfile,
  [componentKeys.IMAGE_BLOCK]: ImageBlock,
  [componentKeys.JOB]: Job,
  [componentKeys.NAVIGATION_ITEM]: Bookmark,
  [componentKeys.PARAGRAPH_WITH_IMAGE]: ParagraphWithImage,
  [componentKeys.SHOP_LIST]: ShopsList,
  [componentKeys.SIMPLE_CONTENT]: SimpleContentCallout,
  [componentKeys.SIMPLE_CONTENT_BLOCK]: ContentBlock,
  [componentKeys.TEAM]: TeamBlock,
  [componentKeys.TEAM_PROFILE]: TeamProfile,
  [componentKeys.TESTIMONIAL_BLOCK]: Testimonial,
  [componentKeys.YOUTUBE_VIDEO]: YoutubeVideo
};

export default componentMap;
